import classNames from 'classnames';
import React, { forwardRef, useState } from 'react';
import alertCircleIcon from 'assets/images/alert-circle.png';
import { PolymorphicElement } from 'types/PolymorphicElement';
import { Text } from '../Typography';
import style from './TextField.scss';

export type TextVariant = 'xl' | 'lg' | 'md' | 'sm' | 'xs';
('xs');
export type TextWeight = 400 | 500 | 600 | 700;

export type TextFieldProps<T extends 'input'> = PolymorphicElement<T> & {
  className?: string;
  label?: React.ReactNode;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  error?: React.ReactNode;
  helperText?: React.ReactNode;
  isMandatory?: boolean;
  disabled?: boolean;
  hasErrorIcon?: boolean;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps<'input'>>((props, ref) => {
  const { className, label, leading, trailing, error, helperText, onClick, disabled, hasErrorIcon = true, ...rest } = props;

  const [isFocused, setIsFocused] = useState(false);

  const handleOnBlue = (event) => {
    setIsFocused(false);
    props?.onBlur?.(event);
  };

  const handleOnFocus = (event) => {
    setIsFocused(true);
    props?.onFocus?.(event);
  };

  return (
    <div className={classNames(style.container, className)} onClick={onClick}>
      {label && (
        <Text variant="sm" className={style.label}>
          {label}
          {props?.isMandatory && <span> *</span>}
        </Text>
      )}
      <div className={classNames(style.inputContainer, props.disabled && style.disabled, error && style.error, isFocused && style.isFocused)}>
        {leading && <span className={style.leading}>{leading}</span>}

        <input ref={ref} {...rest} disabled={disabled} onBlur={handleOnBlue} onFocus={handleOnFocus} className={style.input} />

        {trailing && !error && <span className={style.trailing}>{trailing}</span>}
        {hasErrorIcon && error && <img src={alertCircleIcon} className={style.alertCircleIcon} alt="alert icon" />}
      </div>

      {error && (
        <Text variant="sm" className={classNames(style.marginTop, style.error)}>
          {error}
        </Text>
      )}
      {!error && helperText && (
        <Text variant="sm" className={classNames(style.marginTop, style.helperText)}>
          {helperText}
        </Text>
      )}
    </div>
  );
});
